<template>
  <div class="con-tablex vs-table--content">
    <div class="vs-con-tbody vs-table--tbody ">
      <table :ref="tableRef" class="vs-table vs-table--tbody-table">            
        <thead ref="thead" class="vs-table--thead">
          <vs-th v-for="(column,index) in columns" :key="index" 
                 :class="column.fixed ? fixed-table-column : ''"
                 :style="column.width ? ('width:'+ column.width +'px') : ''">
            {{column.name}}
          </vs-th>
        </thead>
        <!-- <slot name="tbody"></slot> -->
        <tbody v-if="tableData.length > 0">
          <vs-tr :key="indextr" v-for="(tr, indextr) in tableData">
            <vs-td v-for="(column,index) in columns" :key="index" :class="column.fixed ? fixed-table-column : ''">
              <div v-if="column.code == 'index'">{{ indextr+1 }}</div>
              <div v-else :class="column.wareTip ? 'flex-center': ''"> 
                <div v-if="column.wareTip">
                  <div class="ware-tip" :class="tr.wareTipClass">                        
                  </div>
                </div>
                <div :class='tr.tdClass ? tr.tdClass : ""'>{{tr[column.code]}} </div>
              </div>
            </vs-td>
          </vs-tr>
        </tbody>
      </table>
    </div>
    <div v-if="tableData.length == 0" class="vs-table--not-data">
      <img src="@/assets/images/commodity-sys/no-data.png" />
      <div class="nodata-text">{{noDataText}}</div>
    </div>
    <!-- <gc-vs-pagination v-if="pagination" :total="pager.total" v-model="pager.page"
                :max-items="pager.size" :goto="true" class="marTop16"></gc-vs-pagination> -->
    <gc-vs-pagination 
      v-if="pagination == false"
      :pager="pager"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
      ></gc-vs-pagination>
  </div>      
</template>

<script>
  export default {
    name: "commondityTable",
    props: {
      columns: {
        type: Array,
        default: () => {}
      },
      tableData: {
        type: Array,
        default: () => []
      },
      noDataText:{
        type: String,
        default: "暂无数据"
      },
      pagination:{
        type: Boolean,
        default: true
      },
      pager:{
        type: Object,
        default: null
      },
      tableRef:{
        type: String,
        default: "table"
      }
    },
    mounted(){
      if(this.pagination && !this.pager){
        this.pager = this.pagerInner;
        console.log(this.pager);
      }
    },
    data() {
      return { 
        pagerInner:{
          page: 1,
          size: 20,
          total: 0
        } 
      }
    },
    methods: {
      //更改每页条数
      handleSizeChange(val){
        this.$emit('handleSizeChange',val);
      },
      handleCurrentChange(val){
        this.$emit('handleCurrentChange',val);
      }
    }
  }
</script>

<style lang="scss" scoped>
  //固定列样式
  .fixed-table-column{
      position:sticky; 
      right:0;    
      box-shadow: -2px 0 2px rgba(0,0,0,0.02);
      &.white{
          background-color:#fff;
      }
  }
  .vs-con-table.noHeader{
    .header-table.vs-table--header{
        margin: 0;
    }
  }
  .flex-center{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
  }
  .vs-table{
    background-color: #F3F2F7; 
    font-size: 14px;
    padding: 10px;
    border-spacing: 0 0.4rem;
    thead th,  .sort-th, th .vs-table-text{
        font-size: 14px;
        color: #5E5873;
        font-weight: 400;
    } 
    tr{
      color: #6E6B7B;
      td{
          padding: 9px;
          &:first-child, &:last-child{
              border-radius: 0;
          }
      }
    }
    .addTr{
        display: flex;  
        justify-content: flex-start;
        align-items: center; 
        &:hover{
            cursor: pointer;
        } 
        .addIcon{
          font-size: 30px;
          margin-left: 24px;
          margin-right: 8px;
        }
    }
    /deep/ .is-selected{
        background-color: #FFE58F !important;
        box-shadow: 0 0 1px 0 #FFE58F !important;
    }
  }
  .vs-table--not-data{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    img{
        width: 100px;
        height: 100px;
    }
    .nodata-text{
        margin-top: 20px;
    }  
  }
  // 提示
  .ware-tip {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    margin-right: 12px;
    &.add {
      background-color:#74db41 ;
    }
    &.update {
      background-color: #ff8d23;
    }
    &.delete{
      background-color: rgba(var(--vs-danger), 1);
    }
  }
</style>

